(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dama-card-photos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dama-photo-toggle')) {
    let interior = false;
    try { interior = sessionStorage.getItem('dama-interior-photos') === 'true'; } catch {}
    const apply = () => {
      document.documentElement.dataset.damaInterior = String(interior);
      document.querySelectorAll('[data-dama-interior]').forEach(input => { input.checked = interior; });
    };
    apply();
    customElements.define('dama-photo-toggle', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        apply();
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-dama-interior]')) return;
          event.stopPropagation();
          interior = event.target.checked;
          try { sessionStorage.setItem('dama-interior-photos', String(interior)); } catch {}
          apply();
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dama-collection-header"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dama-collection-tools')) {
    const storageKey = 'dama-saved-products-v1';
    let memory = [];
    class DamaCollectionTools extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.shopify-section');
        this.dialog = this.querySelector('dialog');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.items = this.readSaved();
        this.root.addEventListener('click', event => this.onClick(event), options);
        window.addEventListener('storage', event => {
          if (event.key === storageKey) { this.items = this.readSaved(); this.sync(); if (this.dialog.open) this.renderSaved(); }
        }, options);
        requestAnimationFrame(() => { if (this.isConnected) this.sync(); });
      }
      disconnectedCallback() { this.abort?.abort(); }
      readSaved() {
        try {
          const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
          const valid = Array.isArray(saved) ? saved.filter(item => {
            if (!item || !/^\d+$/.test(item.id) || typeof item.title !== 'string') return false;
            try { const url = new URL(item.url, location.origin); return url.origin === location.origin && /\/products\//.test(url.pathname); } catch { return false; }
          }).slice(0, 100) : [];
          memory = valid;
          return valid;
        } catch { this.querySelector('.dama-session-note').hidden = false; return memory; }
      }
      save() {
        memory = this.items;
        try { localStorage.setItem(storageKey, JSON.stringify(this.items)); }
        catch { this.querySelector('.dama-session-note').hidden = false; }
        this.sync();
      }
      sync() {
        this.root.querySelectorAll('[data-dama-save]').forEach(button => button.setAttribute('aria-pressed', String(this.items.some(item => item.id === button.dataset.damaSave))));
        this.root.querySelectorAll('[data-dama-saved-count]').forEach(count => { count.textContent = this.items.length; });
      }
      onClick(event) {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-dama-save')) {
          const id = button.dataset.damaSave;
          const exists = this.items.some(item => item.id === id);
          if (exists) this.items = this.items.filter(item => item.id !== id);
          else this.items = [...this.items.slice(-99), { id, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image }];
          this.save();
          this.querySelector('[data-dama-status]').textContent = exists ? this.dataset.labelRemoved : this.dataset.labelAdded;
        } else if (button.hasAttribute('data-dama-open-saved')) {
          this.opener = button;
          this.renderSaved();
          this.dialog.showModal();
        } else if (button.hasAttribute('data-dama-close')) {
          this.dialog.close();
          this.opener?.focus();
        } else if (button.hasAttribute('data-dama-remove')) {
          this.items = this.items.filter(item => item.id !== button.dataset.damaRemove);
          this.save();
          this.renderSaved();
          this.dialog.querySelector('[data-dama-remove], [data-dama-close]')?.focus();
        }
      }
      renderSaved() {
        const list = this.querySelector('.dama-saved-list');
        list.replaceChildren();
        this.querySelector('.dama-saved-empty').hidden = this.items.length > 0;
        this.items.forEach(item => {
          const li = document.createElement('li');
          const link = document.createElement('a');
          link.href = item.url;
          if (item.image) {
            try {
              const imageURL = new URL(item.image, location.origin);
              if (imageURL.protocol === 'https:' && (imageURL.hostname === location.hostname || imageURL.hostname === 'cdn.shopify.com')) {
                const image = document.createElement('img'); image.src = imageURL.href; image.alt = ''; image.loading = 'lazy'; image.width = 90; image.height = 72; link.append(image);
              }
            } catch {}
          }
          const title = document.createElement('span'); title.textContent = item.title; link.append(title);
          const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'dama-saved-remove'; remove.dataset.damaRemove = item.id; remove.textContent = this.dataset.labelRemove; remove.setAttribute('aria-label', this.dataset.labelRemove + ': ' + item.title);
          li.append(link, remove); list.append(li);
        });
      }
    }
    customElements.define('dama-collection-tools', DamaCollectionTools);
  }
  } catch(e) { console.error(e); }
})();

})();
